import { Option } from '../forms/option';
import { QueueFilterName } from './types';

export const queueFilterOptions: Option<QueueFilterName>[] = [
    { label: 'ALL POLICE', value: 'ALL_POLICE' },
    { label: 'ALL FIRE', value: 'ALL_FIRE' },
    { label: 'ALL EMS', value: 'ALL_EMS' },
    { label: 'POLICE ASSIGNED', value: 'POLICE_ASSIGNED' },
    { label: 'FIRE ASSIGNED', value: 'FIRE_ASSIGNED' },
    { label: 'EMS ASSIGNED', value: 'EMS_ASSIGNED' },
    { label: 'POLICE UNASSIGNED', value: 'POLICE_UNASSIGNED' },
    { label: 'FIRE UNASSIGNED', value: 'FIRE_UNASSIGNED' },
    { label: 'EMS UNASSIGNED', value: 'EMS_UNASSIGNED' },
];
